import React, { FC, memo } from 'react'

import { ErrorHandler } from 'components/error-handler'
import { makeTraceDetails } from 'common'
import { Routes } from 'common/constants'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'

import { useHelpCenterBottomSheet } from '../hooks/useHelpCenterBottomSheet'
import { HelpCenterBottomSheetView } from './HelpCenterBottomSheetView'

export const HelpCenterBottomSheet: FC<{ onClose: () => void }> = memo(({ onClose }) => {
  const { content, isActive, navigateTo } = useHelpCenterBottomSheet()

  if (!content || !isActive) {
    const traceDetails = makeTraceDetails(!!isActive, content)

    return (
      <ErrorHandler
        traceDetails={traceDetails}
        componentName={HelpCenterBottomSheet.name}
        goTo={Routes.HOME}
      />
    )
  }

  return (
    <BottomSheet onClose={onClose}>
      <HelpCenterBottomSheetView content={content} navigateTo={navigateTo} onClose={onClose} />
    </BottomSheet>
  )
})
